import { Post } from "../../../../types/features/Post";
import TableRow from "../../../ui/TableRow";

interface PostRowProps {
  post: Post;
  onAction: (post: Post) => void;
  onSelect?: (post: Post, isSelected: boolean) => void;
  isSelected?: boolean;
  selectable?: boolean;
}

export default function PostRow({ post, onAction, onSelect, isSelected = false, selectable = false }: PostRowProps) {
  const getStatusLabel = () => {
    switch (post.status) {
      case "published":
        return { label: "Publié", className: "text-green-600 bg-green-50" };
      case "draft":
        return { label: "Brouillon", className: "text-gray-600 bg-gray-50" };
      case "archived":
        return { label: "Archivé", className: "text-red-600 bg-red-50" };
      default:
        return { label: "Brouillon", className: "text-gray-600 bg-gray-50" };
    }
  };

  const statusInfo = getStatusLabel();

  return (
    <TableRow
      item={post}
      onAction={onAction}
      onSelect={onSelect}
      isSelected={isSelected}
      selectable={selectable}
      actionable={true}
    >
      <td className="py-3 px-4">
        <div>
          <span className="font-medium text-gray-800 block">{post.title}</span>
          <span className="text-xs text-gray-500">
            {post.status === "published" && post.published_at
              ? `Publié le: ${new Date(post.published_at).toLocaleDateString("fr-FR")}`
              : "Non publié"}
          </span>
        </div>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600">{post.category.name || "-"}</span>
      </td>

      <td className="hidden sm:table-cell py-3 px-4">
        <span className="text-gray-600">{post.author_name || "-"}</span>
      </td>

      <td className="hidden md:table-cell py-3 px-4">
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusInfo.className}`}>{statusInfo.label}</span>
      </td>
    </TableRow>
  );
}
